module.exports = __webpack_public_path__ + "static/img/n_02.fadc8d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/n_02.jpg
// module id = EA0P
// module chunks = 0